<template>
    <div class="ly-settingback sk-settingback" style="overflow: auto">
        <div class="ly-setting" v-if="!config">
            <el-container>
                <el-header>
                    <span class="sk-title">数据库配置</span>
                </el-header>
                <el-main>
                    <el-row class="ly-line">
                        <el-col :span="6" class="sk-required">数据库类型：</el-col>
                        <el-col :span="18">
                            <el-radio-group v-model="db.DBType">
                                <el-radio-button label="1">SQL Server</el-radio-button>
                                <el-radio-button label="2">SQLite</el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <el-row class="ly-line" v-if="db.DBType == 1">
                        <el-col :span="6" class="sk-required">服务器IP：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="db.DBAddress" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6" class="sk-required">核心库名称：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="db.DBName" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line" v-if="db.DBType == 1">
                        <el-col :span="6" class="sk-required">数据库用户：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="db.DBUser" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line" v-if="db.DBType == 1">
                        <el-col :span="6" class="sk-required">数据库密码：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="db.DBPassword" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="24">
                            <el-button type="primary" class="login-button" @click="saveConfig">保存</el-button>
                        </el-col>
                    </el-row>
                </el-main>
            </el-container>
        </div>
        <div class="ly-setting" style="margin-top: 20px" v-if="!root">
            <el-container>
                <el-header>
                    <span class="sk-title">初始化配置</span>
                </el-header>
                <el-main>
                    <el-row class="ly-line">
                        <el-col :span="6" class="sk-required">租户名称：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.TenantName" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6" class="sk-required">租户类型：</el-col>
                        <el-col :span="18">
                            <el-select v-model="tenant.TenantType">
                                <el-option label="客流租户" :value="1"></el-option>
                                <el-option label="商场租户" :value="2"></el-option>
                                <el-option label="公交租户" :value="3"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6">业务数据库名称：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.DBName" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6">租户简称：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.TenantNickName" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6" class="sk-required">管理员账号：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.UserCode" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6" class="sk-required">管理员名称：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.UserName" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6">管理员邮箱：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.Email" />
                        </el-col>
                    </el-row>
                    <el-row class="ly-line">
                        <el-col :span="6">管理员电话：</el-col>
                        <el-col :span="18">
                            <input type="text" v-model="tenant.Phone" />
                        </el-col>
                    </el-row>

                    <el-row class="ly-line">
                        <el-col :span="24">
                            <el-button type="primary" class="login-button" @click="saveTenant">保存</el-button>
                        </el-col>
                    </el-row>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import auth from "../scripts/auth";
import { validator } from "../scripts/validator";
// @ is an alias to /src

export default {
    data() {
        return {
            config: false,
            root: false,
            db: {
                DBType: 1,
                DBAddress: "127.0.0.1",
                DBName: "AJSReportDB",
                DBUser: "ajs",
                DBPassword: "",
                DBDataName: "",
            },
            tenant: {
                TenantType: 1,
                TenantName: "",
                TenantNickName: "",
                UserCode: "admin",
                UserName: "管理员",
                Email: "",
                Phone: "",
                DBID: "",
                DBName: "AjsReportBizDB",
            },
        };
    },
    name: "login",
    components: {},
    created() {
        this.loadState();
    },
    methods: {
        onPickerChanged(data) {
            this.tenant.DistrictID = data.areaID;
        },
        loadState() {
            let _this = this;
            this.$ajax.post("/Platform/IsInit").then(
                (res) => {
                    _this.config = res.Data;
                    if (_this.config) {
                        this.$ajax.post("/Platform/HasTenant").then(
                            (r) => {
                                _this.root = r.Data;
                                if (_this.root) {
                                    _this.$router.push({ path: "/" });
                                }
                            },
                            (res) => _this.$showMsg(res)
                        );
                    }
                },
                (res) => _this.$showMsg(res)
            );
        },
        saveConfig() {
            if (this.db.DBType == 1) {
                if (!validator.required(this.db.DBAddress)) {
                    this.$warn("必须填写服务器IP地址！");
                    return;
                }
            }
            if (!validator.required(this.db.DBName)) {
                this.$warn("必须填写核心库名称！");
                return;
            }
            if (this.db.DBType == 1) {
                if (!validator.required(this.db.DBUser)) {
                    this.$warn("必须填写数据库用户！");
                    return;
                }
                if (!validator.required(this.db.DBPassword)) {
                    this.$warn("必须填写数据库密码！");
                    return;
                }
            }
            let _this = this;
            this.$ajax.post("/Platform/InitConfig", this.db).then(
                (res) => {
                    _this.$success("保存成功！");
                    setTimeout(function () {
                        _this.config = true;
                    }, 1000);
                },
                (res) => _this.$showMsg(res)
            );
        },
        saveTenant() {
            if (!validator.required(this.tenant.TenantName)) {
                this.$warn("必须填写租户名称！");
                return;
            }
            if (!validator.required(this.tenant.DBName)) {
                this.$warn("必须填写数据库名称！");
                return;
            }

            if (!validator.required(this.tenant.UserCode)) {
                this.$warn("必须填写管理员账号！");
                return;
            }
            if (!validator.required(this.tenant.UserName)) {
                this.$warn("必须填写管理员名称！");
                return;
            }
            let _this = this;
            this.$ajax.post("/Platform/InitTenant", this.tenant).then((res) => {
                _this.$success("保存成功！");
                setTimeout(function () {
                    _this.root = true;
                    _this.$router.push({ path: "/" });
                }, 1000);
            });
        },
    },
};
</script>
<style scoped>
.ly-settingback {
    width: 100%;
    height: 100%;
}

.sk-settingback {
    background-color: #2d3a4b;
}

.sk-setting {
    background-color: #cedeeb;
    box-shadow: 0px 0px 10px #cedeeb;
    border-radius: 5px;
}

.ly-setting {
    position: relative;
    top: 10px;
    max-width: 100%;
    padding: 20px;
    margin: 0 auto;
    overflow: hidden;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px #007aff;
}

@media screen and (max-width: 768px) {
    .ly-setting {
        width: calc(96% - 40px);
        margin: 0 2%;
    }
}

@media screen and (min-width: 769px) {
    .ly-setting {
        width: 769px;
    }
}

.ly-setting .ly-line {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 10px 0px;
    display: flex;
    position: relative;
}

.sk-title {
    font-family: 微软雅黑;
    color: #007aff;
    font-size: 24px;
    font-weight: bolder;
}

.icon {
    position: absolute;
    top: 15px;
    left: 10px;
    height: 40px;
    line-height: 40px;
}
.sk-required::before {
    content: "*";
    color: red;
    position: absolute;
    left: -10px;
}
input[type="text"],
input[type="password"] {
    height: 32px;
    line-height: 32px;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

input[type="text"].prefix,
input[type="password"].prefix {
    padding-left: 32px;
}
</style>
